export default {
  text: '#e5d5c1',
  primary: '#cc9a78',
  secondary: '#a26a47',
  background: '#1d2020',
  backgroundSecondary: '#202020',
  light: '#FFF',
  dark: '#020303'
}
